import React, { useEffect, useState } from 'react'
import pelvicSense from "../img/PelvicSense-Logo_FullHorizontal.png"
import {
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBInputGroup,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom"
import Video from "../videos/pelvic_sense_video.mp4"

export const PelvicProgramBanner2 = () => {
  const getWindowDimensions = () => {
    const { innerWidth: width } = window;
    return {
      width,
    };
  };

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });
  return (
    <div className='pelvic-program-banner-2'>
      <div className='text-center banner-2-padding-top p-controller-just-mobile-2'>
        <h3 className='text-al fs-48-32'>Stop Enduring. Start Healing.</h3>
        <p className='text-dm fs-24-16'>Start your healing process now with a digital pelvic care program.</p>
        <img src={pelvicSense} className="image-logo-pelvic-sense"></img>
      </div>
      <div>
        <MDBRow className='mt-4 separations-div'>
          <MDBCol size='12' md="12" lg="6" order={windowDimensions.width <= 1000 ? "2" : "1"} className="video-padding-controller">
            <div className="bg-white p-2 w-90 border-0 rounded">
              <video controls className="actual-video pointer">
                <source src={Video} alt="pelvic-sense" type="video/mp4" />
              </video>
            </div>
          </MDBCol>
          <MDBCol size='12' md="12" lg="6" order={windowDimensions.width <= 1000 ? "1" : "2"} className="fixed-text">

            <div className={windowDimensions.width <= 1000 ? "text-center" : "me-5 mt-2"}>
              <h3 className='text-al fs-32-24'>Elana has teamed up with PelvicSense</h3>
              <p className='mt-4 text-dm fs-20-16'>We have a solution for pelvic pain & pelvic floor dysfunction in online courses led by Evelyn Hecht, Master Clinician of Pelvic Physical Therapy with over 25 years experience. </p>
              <p className='mt-3 text-dm fs-20-16'>Get started on your restorative journey now. Click below to receive a 10% discount, try out the program, and learn more.</p>
              <a href="#selectYourPlan">
                <button className='control-top button-pelvicProgram blue-hover border-0'>START A FREE TRIAL</button>
              </a>
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    </div>
  )
}
